module.exports = __webpack_public_path__ + "img/28_84.fb7634b5.png";